<template>
  <v-stepper non-linear id="fechamento_stepper" v-model="e6" vertical>
    <v-stepper-step color="teal" edit-icon="domain" editable step="1">
      Data de fechamento
      <small>
        Selecione o mês e o ano para o fechamento:
        <br>

        <strong style="font-weight: bold;">{{geraListaMeses[selectedMes]}} de {{selectedAno}}</strong>
      </small>
    </v-stepper-step>

    <v-stepper-content step="1">
      <v-card color="white lighten-1" class="mb-5" style="cursor: pointer;">
        <v-tabs dark v-model="active" color="cyan" show-arrows>
          <v-tabs-slider color="black"></v-tabs-slider>

          <v-tab
            v-for="i in geraListaAno"
            :key="i"
            :href="'#tab-' + i"
            ripple
            @click.native="selectedAno = i; listaMeses = geraListaMeses; selectedMes = 0; activeMes = `tab-Janeiro`"
          >{{ i }}</v-tab>
        </v-tabs>
        <v-tabs dark v-model="activeMes" color="cyan darken-2" show-arrows>
          <v-tabs-slider color="black"></v-tabs-slider>

          <v-tab
            v-for="i in geraListaMeses"
            :key="i"
            :href="'#tab-' + i"
            ripple
            @click.native="selectedMes = geraListaMeses.indexOf(i)"
          >{{ i }}</v-tab>
        </v-tabs>
        <!-- {{activeMes}}
        {{selectedAno}}
        {{selectedMes}}-->
      </v-card>
      <!-- <v-btn small color="primary" @click="e6 = 2">Avançar</v-btn> -->
    </v-stepper-content>

    <v-stepper-step
      color="teal"
      
      id="custom_stepper_header"
      disabled
      step="2"
    >
      NF-e
      <br>
      <small>Especifique informações do documento</small>
      <br>
      <v-switch
        v-for="i in nfes_lista"
        :key="i.id"
        return-object
        v-model="nfes_selected"
        small
        :label="i.text"
        color="success"
        :value="i"
        hide-details
      ></v-switch>
      <!-- <v-chip
        id="chips_fechamento"
        text-color="white"
        v-for="(item, i) in nfes_selected"
        :key="i"
        color="primary"
        @click.native="nfes_selected.splice(i,1)"
      >
        <small>
          <span style="color: white;">{{item.text}}</span>
        </small>
        <div class="v-chip__close">
          <i aria-hidden="true" class="v-icon material-icons">cancel</i>
        </div>
      </v-chip>-->
    </v-stepper-step>

    <!-- <v-stepper-content step="2">
      <v-card class="mb-5 card_fechamento" height>
        
      </v-card>
      <v-btn flat @click="e6 = 1">Voltar</v-btn>
      <v-btn small color="primary" @click="e6 = 3">Avançar</v-btn>
    </v-stepper-content>-->

    <v-stepper-step color="teal" id="custom_stepper_header"  step="3">
      CT-e
      <br>
      <small>Especifique informações do documento</small>
      <br>
      <!-- <v-chip
        id="chips_fechamento"
        text-color="white"
        v-for="(item, i) in ctes_selected"
        :key="i"
        color="primary"
        @click.native="ctes_selected.splice(i,1)"
      >
        <small>
          <span style="color: white;">{{item.text}}</span>
        </small>
        <div class="v-chip__close">
          <i aria-hidden="true" class="v-icon material-icons">cancel</i>
        </div>
      </v-chip>-->

      <v-switch
        v-for="i in ctes_lista"
        :key="i.id"
        return-object
        v-model="ctes_selected"
        small
        :label="i.text"
        color="success"
        :value="i"
        hide-details
      ></v-switch>
    </v-stepper-step>

    <!-- <v-stepper-content step="3">
      <v-card class="mb-5 card_fechamento" height></v-card>
      <v-btn flat @click="e6 = 2">Voltar</v-btn>
      <v-btn color="primary" @click="e6 = 4">Avançar</v-btn>
    </v-stepper-content>-->

    <v-stepper-step color="teal" id="custom_stepper_header"  step="4">
      NFs-e
      <br>
      <small>Especifique informações do documento</small>
      <br>
      <!-- <v-chip
        id="chips_fechamento"
        text-color="white"
        v-for="(item, i) in nfses_selected"
        :key="i"
        color="primary"
        @click.native="nfses_selected.splice(i,1)"
      >
        <small>
          <span style="color: white;">{{item.text}}</span>
        </small>
        <div class="v-chip__close">
          <i aria-hidden="true" class="v-icon material-icons">cancel</i>
        </div>
      </v-chip>-->
      <v-switch
        v-for="i in nfses_lista"
        :key="i.id"
        return-object
        v-model="nfses_selected"
        small
        :label="i.text"
        color="success"
        :value="i"
        hide-details
      ></v-switch>
    </v-stepper-step>
    <!-- <v-stepper-content step="4">
      <v-card class="mb-5 card_fechamento" height></v-card>
      <v-btn flat @click="e6 = 3">Voltar</v-btn>
      <v-btn color="primary" @click="e6 = 5">Avançar</v-btn>
    </v-stepper-content>-->
    <v-stepper-step color="teal" editable step="5">Exportar</v-stepper-step>
    <v-stepper-content :step="5">
      <v-card class="mb-5 card_fechamento">
        <v-layout xs6 align-center justify-center>
          <v-flex align-center justify-center xs12 class="text-xs-center">
            <div class="desc_exportacao">Enviar para E-mail:</div>

            <v-combobox
              v-model="model"
              :filter="filter"
              :hide-no-data="!search"
              :items="items"
              :search-input.sync="search"
              hide-selected
              label="E-mail:"
              multiple
              small-chips
              regular
              @change="handleEmails"
              class="email_combo"
              :menu-props="{contentClass:'email_combo'}"
            >
              <template slot="no-data" style="max">
                <v-list-tile style="max-height: 110px;">
                  <small>
                    Aperte
                    <b>enter</b> para adicionar o e-mail
                  </small>
                  <br>
                  <v-chip
                    class="env_email"
                    :title="search"
                    :color="`${colors[nonce - 1]} lighten-3`"
                    label
                    small
                  >{{ search }}</v-chip>
                </v-list-tile>
              </template>
              <template
                v-if="item === Object(item)"
                slot="selection"
                slot-scope="{ item, parent, selected }"
              >
                <v-chip :color="`${item.color} lighten-3`" :selected="selected" label small>
                  <span class="pr-2">{{ item.text }}</span>
                  <v-icon small @click="parent.selectItem(item)">close</v-icon>
                </v-chip>
              </template>
              <template slot="item" slot-scope="{ index, item }">
                <v-list-tile-content>
                  <v-text-field
                    @click.stop.prevent
                    v-if="editing === item"
                    v-model="editing.text"
                    autofocus
                    flat
                    background-color="transparent"
                    hide-details
                    solo
                    @keyup.enter="edit(index, item)"
                  ></v-text-field>
                  <v-chip v-else :color="`${item.color} lighten-3`" dark label small>{{ item.text }}</v-chip>
                </v-list-tile-content>
                <v-spacer></v-spacer>
                <v-list-tile-action @click.stop>
                  <v-btn icon @click.stop.prevent="edit(index, item)">
                    <v-icon>{{ editing !== item ? 'edit' : 'check' }}</v-icon>
                  </v-btn>
                </v-list-tile-action>
                <v-list-tile-action @click.stop>
                  <v-btn icon @click.stop.prevent="middleDel(item)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </template>
            </v-combobox>
            <v-btn
              color="success"
              @click="downloadFechamento(model.map(item => item.text), empresa)"
            >Enviar</v-btn>
          </v-flex>
          <v-flex align-center justify-center xs12 class="text-xs-center">
            <div class="desc_exportacao">Fazer download:</div>
            <v-btn
              color="yellow darken-2"
              @click="downloadFechamento([conta.email], empresa)"
            >Baixar</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-stepper-content>
    <v-dialog v-model="dialogDelete" max-width="400">
      <v-card>
        <v-card-title class="headline">
          <small>Confirmar remoção de e-mail</small>
        </v-card-title>
        <hr>
        <v-card-text>
          Deseja remover "
          <strong>{{mailDelete ? mailDelete.text : ''}}</strong>" da lista ?
        </v-card-text>
        <hr>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="error" small flat="flat" @click="delMail(false)">Cancelar</v-btn>

          <v-btn small color="success" @click="delMail(true)">Remover</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-stepper>
</template>
<script>
import EmpresaService from "@/domain/conta/empresa/EmpresaService.js";
import UsuarioService from "@/domain/conta/usuario/UsuarioService.js";
export default {
  props: ["empresa", "conta", "alert"],
  data() {
    return {
      e6: 0,
      active: ``,
      model: [],
      search: null,
      selectedAno: "",
      selectedMes: "",
      colors: ["green", "purple", "indigo", "cyan", "teal", "orange"],
      items: [{ header: "Selecione uma opção ou digite um e-mail" }],
      nonce: 1,
      editing: null,
      mailDelete: "",
      listaMeses: [],
      dialogDelete: false,
      meses: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
      ],
      activeMes: "",
      nfes_lista: [
        { id: "recebida", text: "Recebidas", value: "" },
        { id: "emitida", text: "Emitidas", value: "" },
        { id: "pdf", text: "Incluir PDF", value: "" }
      ],
      nfes_selected: [],
      ctes_lista: [
        { id: "tomador", text: "Tomador", value: "" },
        { id: "naoTomador", text: "Não Tomador", value: "" },
        { id: "pdf", text: "Incluir PDF", value: "" }
      ],
      ctes_selected: [],
      nfses_lista: [
        { id: "recebida", text: "Recebidas", value: "" },
        { id: "emitida", text: "Emitidas", value: "" },
        { id: "pdf", text: "Incluir PDF", value: "" }
      ],
      nfses_selected: []
    };
  },
  watch: {
    model(val, prev) {
      if (val.length === prev.length) return;
      this.model = val.map(v => {
        if (v != undefined && v.text != undefined) {
          return v;
        }
        if (
          typeof v === "string" &&
          /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(v)
        ) {
          v = {
            text: v,
            color: this.colors[this.nonce - 1]
          };
          this.items.push(v);

          this.nonce++;
          return v;
        }
      });
    },
    e6: function(oldV, newV) {
      if (newV != 1) {
        this.e6 = 1;
      }
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.active = this.setActiveAno;
      this.activeMes = this.setActiveMes;

      if (this.conta.favEmails && this.conta.favEmails.length > 0) {
        let favMails = this.conta.favEmails.slice();
        for (let i = 0; i < favMails.length; i++) {
          let mail = {};
          mail["text"] = favMails[i];
          mail["color"] = this.colors[
            Math.floor(Math.random() * this.colors.length)
          ];
          this.items.push(mail);
        }
      } else if (!this.conta.favEmail) {
        this.model.push(obj);
        this.items.push(obj);
        obj["text"] = this.conta.email;
        obj["color"] = "info";
      }
    });
  },
  computed: {
    geraListaMeses: function() {
      let listaMeses = [];
      if (this.selectedAno < parseInt(new Date().getFullYear())) {
        listaMeses = this.meses.slice();
      } else {
        listaMeses = this.meses.slice(0, new Date().getMonth() + 1);
      }
      return listaMeses;
    },
    setActiveMes: function() {
      let data = new Date().getMonth();
      this.selectedMes = data;
      let meses = this.geraListaMeses;
      return `tab-${meses[data]}`;
    },
    setActiveAno: function() {
      let data = new Date().getFullYear();
      this.selectedAno = data;
      return `tab-${data}`;
    },
    geraListaAno: function() {
      let ano = parseInt(new Date().getFullYear());
      let listaAno = [];
      for (let i = 2018; i <= ano; i++) {
        listaAno.push(i);
      }
      return listaAno;
    }
  },
  methods: {
    handleEmails() {
      if(this.model.length > 0){
        this.model.map((item, index) => {
          if(!item.text) {
            if (typeof item !== "string" || !/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(item)) {
              this.model.splice(index, 1);
            }
          }
        });
      }
    },
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = val => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      );
    },
    downloadFechamento: function(emails, emprsCnpj) {
      if (!emprsCnpj || emprsCnpj.length == 0) {
        this.alert.resetAlert();
        this.alert.snack.text =
          "Necessário informar ao menos uma empresa para o Fechamento Mensal.";
        this.alert.snack.show = true;
        return;
      }
      if (
        this.nfes_selected.length == 0 &&
        this.ctes_selected.length == 0 &&
        this.nfses_selected.length == 0
      ) {
        this.alert.resetAlert();
        this.alert.snack.text =
          "Necessário especificar informação de ao menos um documento fiscal.";
        this.alert.snack.show = true;
        return;
      }
      if (emails.length < 1) {
        this.alert.resetAlert();
        this.alert.snack.text = "Necessário informar ao menos um E-mail.";
        this.alert.snack.show = true;
        return;
      }
      //emails e emprsCnpj precisam ser array.
      const objEnvio = {
        cpfsCnpjs: emprsCnpj.map(item => item.cnpj),
        nfes:
          this.nfes_selected.length > 0
            ? this.nfes_selected.map(item => item.id)
            : [],
        ctes:
          this.ctes_selected.length > 0
            ? this.ctes_selected.map(item => item.id)
            : [],
        nfses:
          this.nfses_selected.length > 0
            ? this.nfses_selected.map(item => item.id)
            : [],
        data: `${this.selectedMes}-${this.selectedAno}`,
        emails: emails
      };
      this.service = new EmpresaService(this.$http);
      this.alert.resetAlert();
      // this.alert.snack.text = "Processando os documentos";
      // this.alert.snack.show = true;
      // this.alert.snack.time = 4000;
      this.activeGlobalLoader();
      this.service.fechamentoMensal(objEnvio).then(res => {
        if (res.status == 200) {
          this.alert.resetAlert();
          this.alert.snack.text =
            "Processando o Fechamento Mensal, notificaremos por e-mail e na central do Motor Fiscal assim que concluido!";
          this.alert.snack.show = true;
          this.alert.snack.time = 8000;
          this.desactiveGlobalLoader();
        } else {
          this.alert.snackDanger();
          this.alert.snack.text =
            "Motor Fiscal não conseguiu gerar o fechamento mensal";
          this.alert.snack.show = true;
          this.alert.snack.time = 4000;
          this.desactiveGlobalLoader();
        }
      });
    },
    activeGlobalLoader: function() {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      body.classList.add("loading_global");
      html.classList.add("loading_global");

      appDom.classList.add("loading_global");
      icon.classList.add("loading_global");
    },
    edit(index, item) {
      if (!this.editing) {
        this.editing = item;
        this.auxEmail = item.text;
        this.index = index;
      } else {
        if (
          /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/.test(
            this.editing.text
          ) == false
        ) {
          item.text = this.auxEmail;
        }
        this.auxEmail = "";
        this.editing = null;
        this.index = -1;
      }
    },
    desactiveGlobalLoader: function() {
      const appDom = document.querySelector("#app");
      const icon = document.querySelector("#app main +i.c_custom-loader");
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      body.classList.remove("loading_global");
      html.classList.remove("loading_global");
      appDom.classList.remove("loading_global");
      icon.classList.remove("loading_global");
    },
    middleDel(item) {
      this.dialogDelete = true;
      this.mailDelete = item;
    },
    delMail(action) {
      this.dialogDelete = false;
      if (action) {
        this.items.splice(this.items.indexOf(this.mailDelete), 1);
        this.saveMailsFavoritos();
      }
      this.mailDelete = undefined;
    },
    saveMailsFavoritos: async function() {
      let favItems = [];
      for (let i = 1; i < this.items.length; i++) {
        favItems.push(this.items[i].text);
      }
      let userFavMails = {
        favEmails: favItems
      };
      this.conta["favEmails"] = favItems.slice();
      this.service = new UsuarioService(this.$http);
      this.service.editar(userFavMails, this.conta.id_usuario);
    }
  }
};
</script>
<style scoped>
.align_center {
  text-align: center;
}
.desc_exportacao {
  color: darkgrey;
  font-weight: bold;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/stepperFechamentoMes/StepperFechamentoMes.vue